import { useUserVenueSession } from "@shared/modules/venue/hooks/useUserVenueSession";
import { useModelService } from "@shared/services/api/hooks/useModelService";
import VenueBasedMembershipGroupRepository from "../../repositories/VenueBasedMembershipGroupRepository";
import {
  GetMembershipGroupStatsParamsType,
  VenueBasedMembershipGroupStatsSerializer,
} from "../../types/membership-groups";

export function useVenueBasedMembershipGroupService() {
  const { data: currentVenue } = useUserVenueSession();
  const venueId = currentVenue?.id;
  const repository = new VenueBasedMembershipGroupRepository({ venueId });

  const service = useModelService(repository);

  const useMembershipGroupStats = (
    params: GetMembershipGroupStatsParamsType,
    config = {}
  ) => {
    return service.useGenericQuery<VenueBasedMembershipGroupStatsSerializer>(
      "stats",
      {
        injects: { venueId },
        params,
        config,
        options: {
          enabled: Boolean(venueId && params),
          keepPreviousData: true,
          cacheTime: 7 * (60 * 1000), // 7 mins
          staleTime: 5 * (60 * 1000), // 5 mins
        },
      }
    );
  };

  return {
    ...service,
    useMembershipGroupStats,
  };
}

export type UseVenueBasedMembershipGroupService = ReturnType<
  typeof useVenueBasedMembershipGroupService
>;
